import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ReservationService } from '../../service/reservation.service';
import { Router } from '@angular/router';
import { ReservationStatus } from 'src/app/model/reservation-status.model';
import { DataService } from 'src/app/service/data.service';
import { Reservation } from 'src/app/model/reservation.model';
@Component({
  selector: 'app-change-status-dialog',
  templateUrl: './change-status-dialog.component.html',
  styleUrls: ['./change-status-dialog.component.css']
})
export class ChangeStatusDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ChangeStatusDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChangeStatusDialogData,
      reservationService: ReservationService,
       private router: Router,
       dataService: DataService) { this.reservationService = reservationService;
      this.dataService=dataService;}

  ngOnInit() {
    this.dataService.getReservationStatuses().subscribe(data=>{
      this.reservationStatuses=data as ReservationStatus[];
      if(this.reservation.isLessonReservation==1){
      this.reservationStatuses=this.reservationStatuses.filter(x=>x.id!=4)
      }
    })
  }

 
  reservationService: ReservationService
  reservation= this.data.reservation;
  dataService: DataService
  selected = this.data.status.id;
  id= this.data.reservation.id;
  reservationStatuses: ReservationStatus[];

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.reservationService.editReservationStatus(this.id,this.selected).subscribe()
    this.dialogRef.close(this.reservation.isLessonReservation==1?'da':'ne');
  }

/*   onKeydown(event) {
    this.onConfirm();
  } */

}

export interface ChangeStatusDialogData {
  title: string;
  status: ReservationStatus,
  reservation: Reservation;
}

